export default "__VITE_ASSET__DSrfklkl__"